export const ITINERARY_HISTORY_EVENTS = [
  { value: 'updated', label: 'Detalhes atualizados' },
  { value: 'stop_added', label: 'Parada adicionada' },
  { value: 'stop_removed', label: 'Parada removida' },
  { value: 'finalized', label: 'Roteiro finalizado' },
  { value: 'imported', label: 'Inclusão via Upload em massa' },
  { value: 'deleted', label: 'Roteiro excluído' },
  { value: 'status_changed', label: 'Status alterado' },
];
